import React from 'react'
import { Box } from '@mui/material'
import { Icon } from 'packages/eid-icons'
import IconContainer from './IconContainer'
import IconLabel from './IconLabel'

const SkippedIcon = ({ label, color, variant }) => {
    return (
        <Box display="flex" alignItems="center">
            <IconContainer bgcolor="#5d6870">
                <Icon name="Skipped" color="#ffffff" />
            </IconContainer>
            <IconLabel style={{ color: '#5d6870' }}>{label}</IconLabel>
        </Box>
    )
}

export default SkippedIcon
